import { Component, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { VehicleService } from '../vehicle.service'
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-vehicle-table',
  templateUrl: './vehicle-table.component.html',
  styleUrls: ['./vehicle-table.component.scss']
})
export class VehicleTableComponent implements OnInit {

  displayedColumns: string[] = ['id', 'name', 'code', 'licence_number', 'driver_name', 'driver_mobile']
  dataSource: any;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  nameFilter = new FormControl('');
  codeFilter = new FormControl('');
  licenceFilter = new FormControl('');
  driverFilter = new FormControl('');
  driverMobileFilter = new FormControl('');
  filterValues = {
    id: '',
    name: '',
    code: '',
    licence_number: '',
    driver_name: '',
    driver_mobile: '',
  };


  constructor(private global: GlobalService, private http: HttpService, public vehicleService: VehicleService) {
    this.getVehicle();
    this.global.set_master_page_title = 'Vehicle';
    this.vehicleService.downloadVehicle.subscribe((is_new_relation_name_present) => {
      console.log(is_new_relation_name_present);
      if (is_new_relation_name_present) {
        this.getVehicle();
      }
    });
  }


  registerVehicle() {
    console.log('click for register relation type')
    this.VehicleRegister();
    this.vehicleService.vehicleUpdate.emit(null);
    this.vehicleService.set_vehicle_data = null;
  }

  getVehicle() {
    this.http.getVehicle().subscribe((data: VEHICLE[]) => {
      console.log(data);
      this.dataSource = new MatTableDataSource<VEHICLE>(data);
      this.dataSource.sort = this.sort;
      this.dataSource.data = data;
      this.dataSource.filterPredicate = this.createFilter();
    }, (error) => {
      console.log(error);
    });
  }

  editVehicle(relation_type) {
    this.VehicleRegister();
    this.vehicleService.vehicleUpdate.emit(relation_type);
    this.vehicleService.set_vehicle_data = relation_type;
  }

  VehicleRegister() {
    this.vehicleService.is_display_vehicle_register_component = true;
  }

  hideVehicleRegister() {
    this.vehicleService.is_display_vehicle_register_component = false;
  }

  ngOnInit() {
    console.log('ng funct');
    this.nameFilter.valueChanges
      .subscribe(
        name => {
          this.filterValues.name = name;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.codeFilter.valueChanges
      .subscribe(
        code => {
          this.filterValues.code = code;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.licenceFilter.valueChanges
      .subscribe(
        licence_number => {
          this.filterValues.licence_number = licence_number;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.driverFilter.valueChanges
      .subscribe(
        driver_name => {
          this.filterValues.driver_name = driver_name;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )
    this.driverMobileFilter.valueChanges
      .subscribe(
        driver_mobile => {
          this.filterValues.driver_mobile = driver_mobile;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      )

  }

  createFilter():
    (data: any, filter: string) => boolean {
    console.log('filter')
    let filterFunction = function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return data.name.toString().toLowerCase().indexOf(searchTerms.name.toString().toLowerCase()) !== -1
        && data.code.indexOf(searchTerms.code) !== -1
        && data.licence_number.indexOf(searchTerms.licence_number) !== -1
        && data.driver_mobile.indexOf(searchTerms.driver_mobile) !== -1
        && data.driver_name.toString().toLowerCase().indexOf(searchTerms.driver_name.toString().toLowerCase()) !== -1;
    }
    return filterFunction;
  }

}

export interface VEHICLE {
  id: number;
  name: string;
}